import React from 'react';

import styled from '@emotion/styled';

import { getStateLayerColor } from '@web/ui/theme/utils';

import { BaseTile } from '../common';

import BoostAnimation from './boost.gif?url';

const Container = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing('0500')};
  grid-template-rows: 1fr auto;
  text-shadow: 0px 0px 4px ${({ theme }) => theme.color.greenFixed};
`;

const BoostTile = styled(BaseTile)`
  padding: ${({ theme }) => theme.spacing('1000')};
  background-image: ${getStateLayerColor('greenFixed', 'semiTransparent')},
    url('${BoostAnimation}');
  background-size:
    auto,
    auto 75%;
  background-position: center;
  background-repeat: no-repeat;
  height: 18.5rem;
`;

const TileTitle = styled.span`
  font-size: ${({ theme }) => theme.typescale.size['0750']};
`;

interface IStakingBoost {
  children: React.ReactNode;
  titleComponent: React.ReactNode;
  timer: React.ReactNode;
}

export const StakingBoost = ({
  titleComponent,
  children,
  timer,
}: IStakingBoost) => {
  return (
    <Container>
      <BoostTile>
        <TileTitle>{titleComponent}</TileTitle>
        {children}
      </BoostTile>
      {timer}
    </Container>
  );
};
